import FieldConfig from "../../../../proto/field-config";
import FieldDate from "../../../../generic/datetime/date/date";
import Task from "../../../../../model2/task/task";
import ItemModel from "../../../../../model2/item/item-model";
import FieldTaskSchedule_Popover from "./components/popover/popover";
import FieldTaskSchedule_TableCell from "./render/table/table-cell";
import {LifecycleAction} from "../../../../../gd/const/lifecycle";
import TableManager from "../../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager";
import {ScheduleStatus} from "../../../../../gd/types/types";
import DatetimeUtils from "../../../../../gd/utils/datetime-utils"
import {SortDirection} from "../../../../../data-structures/sort"

export const SCHEDULE_SOMEDAY = 'schedule-someday'

export default class FieldTaskSchedule extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-schedule'
        this.label              = 'Schedule date'

        this.minDate            = moment()
        this.fieldParams.highlightIfPastdue = true
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

        this.components.PopoverMenu     = FieldTaskSchedule_Popover
        this.renderComponents.tableCell = FieldTaskSchedule_TableCell
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeScheduleDate
    }

    // Custom Methods
    listItemSortFunctions(sort: SortDirection):any {
        return {
            functions: [
                (listItem:ItemModel) => {
                    switch (listItem.task?.scheduleStatus) {
                        case ScheduleStatus.SOMEDAY:
                            return 2

                        case ScheduleStatus.SCHEDULED:
                            return 1

                        case ScheduleStatus.NOT_SCHEDULED:
                        default:
                            return 0
                    }
                },
                (listItem:ItemModel) => {
                    switch (listItem.task.scheduleStatus){
                        case ScheduleStatus.SCHEDULED:
                            return DatetimeUtils.dateToMoment(listItem.task.scheduleDate!).format('x')

                        default:
                            return ''
                    }
                }
            ],
            directions: [sort, sort]
        }
    }

    // used to be
    tableCellOnValueChange = async (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {

        if (value === SCHEDULE_SOMEDAY) {
            item.task.updateSchedule(null, ScheduleStatus.SOMEDAY)
        } else if (!value) {
            item.task.updateSchedule(null, ScheduleStatus.NOT_SCHEDULED)
        } else {
            item.task.updateSchedule(value, ScheduleStatus.SCHEDULED)
        }

        item._updateLastUpdateTime() // otherwise it wont re-render

        // Aggregated values...
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

        // strange if it's about it WAITS without await ...
        item.task.save()

    }

}
